import React from "react";
import {useState, useEffect} from "react";
import Form from 'react-bootstrap/Form';
const Todo = () => {
    // code obtained from zen quotes api documentation, except for useEffect
    //https://docs.zenquotes.io/zenquotes-documentation/
    const quoteURL = `https://zenquotes.io/api/quotes/random`;

    //creates the variable shell which will be filled laater once api loaded
    const [quote, setQuote] = useState(null);
    async function quoteAPI() {
        try {
            const response = await fetch(quoteURL);
            const data = await response.json();
            //concatenates with - as a separator
            setQuote(`${data[0].q} - ${data[0].a}`);
        } catch (error) {
            console.error("Error occurred when fetching Quote API data", error);
            setQuote("Error occurred when fetching Quote API data");
        }
    }
    useEffect(() => {
        quoteAPI();
    }, []);

    const [todo, setTodo] = useState([]);
    const [todone, setTodone] = useState([]);
    const [input, setInput] = useState("");

    //get saved todos
    useEffect(() => {
        //if there isn't anything saved, then default to blank []
        const savedTodos = JSON.parse(localStorage.getItem("todo")) || [];
        setTodo(savedTodos);
    }, []);

    const addTodo = () =>{
        if (input != ""){
            const tempDuplicateList = [...todo, input];
            setTodo(tempDuplicateList);
            //then save the new todo item to local storage
            localStorage.setItem("todo", JSON.stringify(tempDuplicateList));
            setInput("");
        }
    }
    const enterPressed = (e) => {
        if (e.key === "Enter") {
            addTodo()
        }
    }

    const todoDone = (index) => {
        //gets the index of the completed item and uses that to find the done task
        const indexedTodo = todo[index];
        //then adds to existing (...) todone column
        setTodone([...todone, indexedTodo]);
        //then removes done task from todo
        todo.splice(index, 1);
        //updates the todo array
        setTodo(todo);
        const ding = new Audio("./ding-101492.mp3");
        ding.play();
    }

    return (
        <>
            <header>
                <h1 className="heading1">Todo</h1>
                <h2 className="heading2">
                    {quote || "Fetching Quote API"}
                </h2>
            </header>

            <main>
                <div className="todo-container" aria-labelledby="todo-heading">
                    <div className="todo-items">
                        <h3 id="todo-heading">To-dos</h3>
                            {todo.map((todo, index) => (
                                <Form.Check
                                    aria-label={`Tick off To-do item: ${todo}`}
                                    key={index}
                                    type="checkbox"
                                    label={todo}
                                    onChange={e => {todoDone(index)}}
                                />
                            ))}
                    </div>
                    <div className="done-items" aria-labelledby="done-heading">
                        <h3 id="done-heading">To-dones</h3>
                        <ul>
                            {todone.map((todone, index) => (
                                <li key={index}>
                                    {todone}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="todo-inputs">
                    <input
                        type="text"
                        className="form-control"
                        id="todoInput"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={enterPressed}
                        placeholder="Type a new todo here!"
                        aria-placeholder="Enter a new task"
                    />
                    <button
                        className="btn btn-outline-secondary"
                        aria-label="Add a new task"
                        id="button"
                        onClick={addTodo}>
                        Add New Task
                    </button>
                </div>
            </main>
        </>
    );
};
export default Todo;